<section class="project-section">

    <app-banner-project></app-banner-project>

    <app-carousel></app-carousel>

    <div class="grid-section">
        <div class="projects-header" style="margin-top: 50px;">
            <h2>Tu sueño, nuestro proyecto</h2>
            <p>Cada proyecto refleja nuestro compromiso con la calidad, la innovación y la satisfacción de nuestros
                clientes.</p>

            <div class="search-container">
                <svg class="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                    stroke-width="2">
                    <circle cx="11" cy="11" r="8"></circle>
                    <path d="m21 21-4.35-4.35"></path>
                </svg>

                <div class="search-input-container">
                    <input type="text" placeholder="Buscar proyectos..." [(ngModel)]="searchTerm"
                        (input)="onSearchChange(searchTerm)" class="search-input" />
                    <button class="clear-search" *ngIf="searchTerm" (click)="clearSearch()">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <line x1="18" y1="6" x2="6" y2="18"></line>
                            <line x1="6" y1="6" x2="18" y2="18"></line>
                        </svg>
                    </button>
                </div>

            </div>

            <!-- Filter Tabs -->
            <div class="filter-tabs-container">
                <button class="tab-button" [class.active]="selectedArea === null" (click)="selectArea(null)">
                    Todos los sectores
                </button>
                <button class="tab-button" [class.active]="selectedArea === 'Público'" (click)="selectArea('Público')">
                    Sector Público
                </button>
                <button class="tab-button" [class.active]="selectedArea === 'Industrial y Comercial'" (click)="selectArea('Industrial y Comercial')">
                    Industrial y Comercial
                </button>
                <button class="tab-button" [class.active]="selectedArea === 'Salud'" (click)="selectArea('Salud')">
                    Sector Salud
                </button>
                <button class="tab-button" [class.active]="selectedArea === 'Vivienda'" (click)="selectArea('Vivienda')">
                    Vivienda y Desarrollos
                </button>
            </div>
        </div>

        <!-- grid section -->
        <div class="projects-grid" *ngIf="hasResults">
            @for (project of paginatedProjects; track project.id) {
            <app-card-project [project]="project"></app-card-project>
            }
        </div>

        <!-- No results message -->
        <div class="no-results" *ngIf="!hasResults">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <circle cx="11" cy="11" r="8"></circle>
                <path d="m21 21-4.35-4.35"></path>
                <line x1="11" y1="8" x2="11" y2="14"></line>
                <line x1="8" y1="11" x2="14" y2="11"></line>
            </svg>
            <h3>No se encontraron proyectos</h3>
            <p>Intenta con otros términos de búsqueda o ajusta los filtros.</p>
            <button class="btn-reset-search" (click)="resetFilters()">
                Limpiar búsqueda y filtros
            </button>
        </div>

        <!-- Pagination -->
        <div class="pagination-container" *ngIf="hasResults && totalPages > 1">
            <button class="pagination-btn" (click)="previousPage()" [disabled]="currentPage === 1">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="15 18 9 12 15 6"></polyline>
                </svg>
            </button>

            <div class="pagination-numbers">
                @for (page of getPageNumbers(); track page) {
                    @if (page === -1) {
                        <span class="pagination-ellipsis">...</span>
                    } @else {
                        <button 
                            class="pagination-number" 
                            [class.active]="currentPage === page"
                            (click)="goToPage(page)">
                            {{ page }}
                        </button>
                    }
                }
            </div>

            <button class="pagination-btn" (click)="nextPage()" [disabled]="currentPage === totalPages">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <polyline points="9 18 15 12 9 6"></polyline>
                </svg>
            </button>
        </div>



    </div>
</section>

<!-- Modal filters -->
<!-- Modal filters (Oculto como se solicitó)
<div class="modal-overlay" *ngIf="modalVisible" (click)="modalVisible = false" [@fadeIn]>
    <div class="modal-container" (click)="$event.stopPropagation()" [@slideIn]>
        <div class="modal-header">
            <h3>Filtrar por sector</h3>
            <button class="close-btn" (click)="modalVisible = false">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                    <line x1="18" y1="6" x2="6" y2="18"></line>
                    <line x1="6" y1="6" x2="18" y2="18"></line>
                </svg>
            </button>
        </div>

        <div class="modal-content">
            <div class="filter-options">
                <button class="filter-option" [class.active]="selectedArea === null" (click)="selectArea(null)">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="3" y="3" width="7" height="7"></rect>
                        <rect x="14" y="3" width="7" height="7"></rect>
                        <rect x="14" y="14" width="7" height="7"></rect>
                        <rect x="3" y="14" width="7" height="7"></rect>
                    </svg>
                    <span>Todos los sectores</span>
                    <svg *ngIf="selectedArea === null" class="check-icon" width="20" height="20" viewBox="0 0 24 24"
                        fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                </button>

                <button class="filter-option" [class.active]="selectedArea === 'Público'"
                    (click)="selectArea('Público')">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                        <polyline points="9 22 9 12 15 12 15 22"></polyline>
                    </svg>
                    <span>Sector Público</span>
                    <svg *ngIf="selectedArea === 'Público'" class="check-icon" width="20" height="20"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                </button>

                <button class="filter-option" [class.active]="selectedArea === 'Industrial y Comercial'"
                    (click)="selectArea('Industrial y Comercial')">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <rect x="2" y="7" width="20" height="14" rx="2" ry="2"></rect>
                        <path d="M16 21V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                    </svg>
                    <span>Industrial y Comercial</span>
                    <svg *ngIf="selectedArea === 'industrial_commercial'" class="check-icon" width="20" height="20"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                </button>

                <button class="filter-option" [class.active]="selectedArea === 'Salud'" (click)="selectArea('Salud')">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path
                            d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z">
                        </path>
                    </svg>
                    <span>Sector Salud</span>
                    <svg *ngIf="selectedArea === 'healthcare'" class="check-icon" width="20" height="20"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                </button>

                <button class="filter-option" [class.active]="selectedArea === 'Vivienda'"
                    (click)="selectArea('Vivienda')">
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path>
                    </svg>
                    <span>Vivienda y Desarrollos</span>
                    <svg *ngIf="selectedArea === 'housing'" class="check-icon" width="20" height="20"
                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                </button>
            </div>

            <div class="filter-actions">
                <button class="btn-reset" (click)="resetFilters()">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                        <polyline points="23 4 23 10 17 10"></polyline>
                        <polyline points="1 20 1 14 7 14"></polyline>
                        <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"></path>
                    </svg>
                    Limpiar filtros
                </button>
            </div>
        </div>
    </div>
</div>
-->